import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHotel } from '@fortawesome/free-solid-svg-icons';
import useSearchHooks from '../../../store/hotel/search-hooks';

export default function HotelNameSelection() {
  const { setHotelName, search } = useSearchHooks();

  return (
    <div className="rs_form_row rs_autosuggest_row rs_1365_100">
      <FontAwesomeIcon icon={faHotel} className="fa-location-icon" />
      <p className={search.hotelName ? 'hide-placeholder d-block' : 'hide-placeholder '}>Hotel Name</p>
      <input
        name="query"
        className={search.hotelName ? 'rs_autosuggest_act rs_autosuggest' : 'rs_autosuggest'}
        type="text"
        title="Enter a Hotel Name"
        value={search.hotelName}
        autoComplete="off"
        onChange={(e) => {
          setHotelName({ hotelName: e.target.value.toLowerCase() });
        }}
        placeholder="Hotel Name..."
      />
    </div>
  );
}
